"use client";

import { Mail, Phone, PhoneCall } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Contact() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const grid = useRevealOnScroll<HTMLDivElement>();
  const footer = useRevealOnScroll<HTMLDivElement>();
  const channels = [{
    type: "general",
    icon: Phone,
    label: "[ OFFICE LINE ]",
    heading: "General service inquiries",
    contact: "(475) 219-1020",
    contactHref: "tel:+18605550123",
    hours: "Mon–Fri 8am–5pm"
  }, {
    type: "email",
    icon: Mail,
    label: "[ EMAIL US ]",
    heading: "Administrative requests",
    contact: "Jrodrigues@waterswellinc.org",
    contactHref: "mailto:support@waterswell.org",
    hours: "Response within 24 hours"
  }];
  return <section data-section-id="855" id="reach-out-to-us" className="bg-background text-foreground">
      <div className="mx-auto max-w-7xl px-6 py-20 sm:py-24 lg:px-8 lg:py-28">
        <div ref={header.ref} className={`mx-auto max-w-3xl text-center transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs sm:text-sm tracking-[0.2em] uppercase mb-6 text-muted-foreground">
            [ CONNECT WITH US ]
          </p>
          <h2 className="font-serif font-default text-foreground leading-[1.1]" style={{
          fontSize: "clamp(2.5rem, 5vw, 4.5rem)"
        }}>
            We are here to{" "}
            <span className="italic text-accent-foreground">
              support you.
            </span>
          </h2>
          <p className="mt-6 font-default text-lg sm:text-xl leading-relaxed text-muted-foreground">
            Waters Well Inc. provides dedicated support for individuals and families. Reach out to our team to discuss your specific needs and service requirements.
          </p>
        </div>

        <div ref={grid.ref} className={`mt-16 sm:mt-20 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 transition-all duration-700 ease-out delay-150 ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {channels.map((channel, i) => {
          const Icon = channel.icon;
          const isEmergency = channel.type === "emergency";
          return <div key={channel.type} data-index={i} className="group relative flex flex-col rounded-lg p-10 lg:p-12 transition-all duration-300 hover:-translate-y-1 border border-border shadow-md bg-accent">
                <div className="mb-8">
                  <Icon className="h-8 w-8 text-primary" strokeWidth={1.5} aria-hidden="true" />
                </div>

                <p className="font-mono text-xs tracking-[0.2em] uppercase mb-5 text-muted-foreground">
                  {channel.label}
                </p>

                <h3 className="font-serif font-default text-2xl sm:text-[1.75rem] leading-tight mb-6 text-foreground">
                  {channel.heading}
                </h3>

                <Link to={channel.contactHref} className="font-default font-semibold leading-tight break-words transition-opacity hover:opacity-80 text-primary" style={{
              fontSize: "1.5rem"
            }}>
                  {channel.contact}
                </Link>

                <div className="mt-8 mb-5 h-px w-full bg-border" />

                
              </div>;
        })}
        </div>

        <div ref={footer.ref} className={`mt-16 sm:mt-20 flex items-center justify-center gap-3 transition-all duration-700 ease-out delay-300 ${footer.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-lg opacity-75 bg-chart-4" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-lg bg-chart-4" />
          </span>
          <p className="font-serif font-default italic text-lg sm:text-xl text-foreground">
            Professional care, delivered with empathy.
          </p>
        </div>
      </div>
    </section>;
}